<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav active">在线文档</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">地址：使用接入方提供的URL</p>
          <p class="api_addr_info">请求方法：<span>POST</span></p>
          <p class="api_addr_info">
            数据类型：<span>X-WWW-FORM-URLENCODED </span>
          </p>
          <p class="api_addr_info">响应类型：<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import onlineDoc from '../components/onlineDoc'
export default {
  components: { onlineDoc },
  data() {
    return {
      onlineData: {
        //接口描述
        apiDesc: '与平台签约的客户，可通过此接口接收干线加班车招采的订单',
        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: 'Headers',
            value: [
              {
                name: 'apiAccount',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '接入方在平台的api账户标识'
              },
              {
                name: 'digest',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '签名字符串'
              },
              {
                name: 'timestamp',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '时间戳，毫秒'
              }
            ]
          },
          {
            title: '请求参数',
            value: [
              {
                name: 'bizContent',
                type: 'String',
                require: 'Y',
                normal: '业务参数',
                describe: '业务参数模块内json格式的string类型'
              }
            ]
          },
          {
            title: '业务参数',
            value: [
              {
                name: 'tenderNo',
                type: 'String(30)',
                require: 'Y',
                normal: '',
                describe: '需求编码'
              },
              {
                name: 'bidStartTime',
                type: 'String',
                require: 'N',
                normal: '2024-09-05 00:00:00',
                describe: '招标开始时间（yyyy-MM-dd HH:mm:ss）'
              },
              {
                name: 'bidEndTime',
                type: 'String',
                require: 'N',
                normal: '2024-09-05 23:59:59',
                describe: '招标结束时间（yyyy-MM-dd HH:mm:ss）'
              },
              {
                name: 'bidRound',
                type: 'Integer',
                require: 'Y',
                normal: '2',
                describe: '轮次'
              },
              {
                name: 'operationModel',
                type: 'Integer',
                require: 'Y',
                normal: '1',
                describe: `线路运行模式 ：<br />1-单边<br />2-对开<br />3-往返`
              },
              {
                name: 'platformTime',
                type: 'String',
                require: 'N',
                normal: '2024-09-05 23:59:59',
                describe: '靠台时间（yyyy-MM-dd HH:mm:ss）'
              },
              {
                name: 'estimateDepartureTime',
                type: 'String',
                require: 'N',
                normal: '2024-09-06 09:59:59',
                describe: '预计发车时间（yyyy-MM-dd HH:mm:ss）'
              },
              {
                name: 'estimateArrivalTime',
                type: 'String',
                require: 'N',
                normal: '2024-09-06 09:59:59',
                describe: '预计到车时间（yyyy-MM-dd HH:mm:ss）'
              },
              {
                name: 'totalUseTime',
                type: 'Integer',
                require: 'N',
                normal: '',
                describe: `在途时长（min）`
              },
              {
                name: 'vehicleTypeName',
                type: 'String(30)',
                require: 'N',
                normal: '',
                describe: `车型`
              },
              {
                name: 'axleNumber',
                type: 'Integer(2)',
                require: 'N',
                normal: '',
                describe: `轴数`
              },
              {
                name: 'limitedPrice',
                type: 'Number(11)',
                require: 'N',
                normal: '',
                describe: `限价`
              },
              {
                name: 'bidContact',
                type: 'String(30)',
                require: 'N',
                normal: '',
                describe: `招标联系人`
              },
              {
                name: 'bidContactPhone',
                type: 'String(30)',
                require: 'N',
                normal: '',
                describe: `招标联系人电话`
              },
              {
                name: 'bidContactMailbox',
                type: 'String(100)',
                require: 'N',
                normal: '',
                describe: `招标联系人邮箱`
              },
              {
                name: 'startProviderDesc',
                type: 'String(20)',
                require: 'N',
                normal: '',
                describe: `始发省份`
              },
              {
                name: 'startCityDesc',
                type: 'String(100)',
                require: 'N',
                normal: '',
                describe: `始发城市`
              },
              {
                name: 'startNetworkName',
                type: 'String(100)',
                require: 'N',
                normal: '',
                describe: `始发转运中心`
              },
              {
                name: 'startAddress',
                type: 'String(300)',
                require: 'N',
                normal: '',
                describe: `始发详细地址`
              },
              {
                name: 'endProviderDesc',
                type: 'String(200)',
                require: 'N',
                normal: '',
                describe: `目的省份`
              },
              {
                name: 'endCityDesc',
                type: 'String(100)',
                require: 'N',
                normal: '',
                describe: `目的城市`
              },
              {
                name: 'endNetworkName',
                type: 'String(100)',
                require: 'N',
                normal: '',
                describe: `目的转运中心`
              },
              {
                name: 'endAddress',
                type: 'String(300)',
                require: 'N',
                normal: '',
                describe: `目的详细地址`
              },
              {
                name: 'halfwayName',
                type: 'String(200)',
                require: 'N',
                normal: '',
                describe: `经停地点`
              },
              {
                name: 'singleMileage',
                type: 'Integer',
                require: 'Y',
                normal: '',
                describe: `单边里程（km）`
              },
              {
                name: 'pointList',
                type: 'List<PointBean>',
                require: 'N',
                normal: '',
                describe: `经停信息List`
              }
            ]
          },
          {
            title: 'PointBean经停信息类型说明',
            value: [
              {
                name: 'networkName',
                type: 'String(100)',
                require: 'N',
                normal: '',
                describe: '经停网点'
              },
              {
                name: 'rangeAddress',
                type: 'String(300)',
                require: 'N',
                normal: '',
                describe: '经停地址'
              },
              {
                name: 'sortNum',
                type: 'Integer',
                require: 'N',
                normal: '',
                describe: '经停序号：1-开始'
              },
              {
                name: 'rangeList',
                type: 'List<String>',
                require: 'N',
                normal: '["合肥出港1007"]',
                describe: `场地集合<br />场地名称集合`
              }
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: '响应参数',
            value: [
              {
                name: 'code',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '返回码，见附录'
              },
              {
                name: 'msg',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '描述'
              },
              {
                name: 'data',
                type: 'Object',
                require: 'Y',
                normal: '',
                describe: '业务数据'
              }
            ]
          }
        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1362
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {"axleNumber":1,"bidContact":"yyn","bidContactPhone":"17521711969","bidEndTime":"2024-12-06 20:00:00","bidRound":1,"bidStartTime":"2024-12-06 08:00:00","endAddress":"上海市松江区佘山镇强业路154号","endCityDesc":"芜湖市","endNetworkName":"芜湖转运中心","endProviderDesc":"安徽省","estimateArrivalTime":"2024-09-05 01:00:00","estimateDepartureTime":"2024-09-05 00:00:00","limitedPrice":9990,"operationModel":1,"platformTime":"2024-09-04 00:00:00","singleMileage":254741.56,"pointList":[{"networkName":"合肥转运中心8880","rangeAddress":"E通世界科技园","rangeList":["合肥出港1007"],"sortNum":1},{"networkName":"芜湖转运中心123","rangeAddress":"上海市松江区佘山镇强业路154号","rangeList":["芜湖"],"sortNum":2}],"startAddress":"E通世界科技园","startCityDesc":"合肥市","startNetworkName":"合肥转运中心","startProviderDesc":"安徽省","tenderNo":"XQBM202408270006"}`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success"
}
`),
        //错误代码提示
        errcodeJson: []
      }
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '../../css/apiTest.scss';
</style>
